<template>
  <el-container class="app-container">
    <el-header ref="elHeaderLayout" class="app-header" style="height: unset;">
      <myHeader />
    </el-header>
    <el-container>
      <!-- <div style="width:auto;max-height:100%;overflow:hidden;height: calc(100vh - 60px);" ref="elAsideMyNav"> -->
      <el-aside
        ref="elAsideMyNav"
        width="auto"
        :class="'scrollAside'"
        style="background-color: #0271B3;"
      >
        <el-scrollbar ref="elScrollbarMyNav" class="myNavScrollbar">
          <myNav
            ref="myNavItem"
            :is-collapse="navMenuCollapse"
            :active-index="activeIndex"
          />
        </el-scrollbar>
      </el-aside>
      <el-container style="background-color:#F5F6FA;width:100%;">
        <el-header height="33px" class="main-header">
          <el-link
            :icon="
              navMenuCollapse === true ? 'el-icon-ali-gengduo' : 'el-icon-ali-gengduo'
            "
            style="font-size:17px;color:#057CBF"
            :underline="false"
            @click="toggleMenu"
          />
          <el-breadcrumb
            separator="/"
            style="margin-left:7px; font-size:14px;"
            class="main-breadcrumb"
          >
            <template v-for="(item, index) in breadcrumbList">
              <el-breadcrumb-item
                v-if="item.name === 'layout'"
                :key="item.path"
                :to="breadcrumbList.length > 1 ? { path: item.path } : ''"
              >{{ $t(item.meta.title) }}</el-breadcrumb-item>
              <el-breadcrumb-item v-else :key="item.path">
                <span
                  :style="
                    index == breadcrumbList.length - 1
                      ? 'color:rgba(53,104,132,1);'
                      : 'color:#999999;'
                  "
                >{{ $t(item.meta.title) }}</span></el-breadcrumb-item>
            </template>
          </el-breadcrumb>
        </el-header>
        <el-main ref="elMain" :key="elMainKey" class="main-container" style="padding:0 10px;">
          <!-- <el-scrollbar class="myNavScrollbar">
            <div style="padding:0 10px; min-width:1100px;">
              <router-view />
            </div>
          </el-scrollbar> -->

          <router-view style="min-width:1100px;" />
        </el-main>
      </el-container>
    </el-container>

    <el-dialog
      v-if="loginDialogVisible"      
      :lock-scroll="true"
      :show-close="true"
      :visible.sync="loginDialogVisible"
      width="650px"
      :fullscreen="false"
      :modal="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :center="true"
      top="10vh"
      custom-class="el-dialog-loginDialog"
    >
      <login-dialog style="height:480px;min-height: 480px;width:100%;min-width:100%;"/>
    </el-dialog>
  </el-container>
</template>

<script>
import myHeader from './header'
import myNav from './nav'
import commonRoutes from '@/router/commonRoute'
import dynamicRoutes from '@/router/dynamicRoute'
import permissionOperate from '@/utils/permissionOperate'
import loginDialog from '@/views/login/loginDialog.vue'

export default {
  components: { myHeader, myNav, loginDialog },
  mixins: [],
  props: {},
  data() {
    return {
      elMainKey: 0,
      navMenuCollapse: false, // 导航菜单的状态
      breadcrumbList: [], // 面包屑列表
      activeIndex: '', // 激活导航的序号
      breadCrumbRoutePComputeCount: 1, // 面包屑计算数量
      loginDialogVisible: false
    }
  },
  computed: {
    lang() {
      return this.$store.state.app.language
    }
  },
  watch: {
    $route(to) {
      const isSetActiveIndex = !this.$refs.myNavItem.isClickMenuItem // 点击则不设置，不点击则设置
      this.LoadBreadCrumbList(this, to, isSetActiveIndex)
      this.$refs.myNavItem.isClickMenuItem = false // 不是点击菜单项
      if(to.name != 'layout' && (!this.breadcrumbList || this.breadcrumbList.length == 0)){
        //当导航中没有该路由时，根据路由加载面包屑
        this.LoadBreadCrumbListByRoute(this, to, false, false)
      }

      if(this.$refs.elMain.$el.scrollTop){
        this.$refs.elMain.$el.scrollTop = 0
      }

      window.isRouteChange = true
    },
    lang() {
      // this.elMainKey++;
    }
  },
  created() {},
  mounted() {
    // 加载面包屑
    this.LoadBreadCrumbList(this, this.$route, true)
    if(this.$route.name != 'layout' && (!this.breadcrumbList || this.breadcrumbList.length == 0)){
      //当导航中没有该路由时，根据路由加载面包屑
      this.LoadBreadCrumbListByRoute(this, this.$route, false, false)
    }

    // 给aside动态高度，以便于滚动条的计算，如果没有固定高度，el-scrollbar的高度计算就会出错
    this.$refs.elAsideMyNav.$el.style.height =
      'calc(100vh - ' +
      window.getComputedStyle(this.$refs.elHeaderLayout.$el).height +
      ')'

    window.addEventListener('resize', () => {
      this.$refs.elScrollbarMyNav.update()
    })

    // window.addEventListener("switchHandler", () => {
    //   this.elMainKey++;
    // });
    window.layoutObj = this
  },
  destroyed() {},
  methods: {
    openLoginDialog(){
      this.loginDialogVisible = true
    },
    closeLoginDialog(){
      this.loginDialogVisible = false
    },
    toggleMenu() {
      this.navMenuCollapse = !this.navMenuCollapse
      this.$store.commit('setNavbarExpand', !this.navMenuCollapse)
    },
    LoadBreadCrumbListByRoute(thisObj, routeItemCur, isSetActiveIndex, isOnlyShowCurRoute) {
      // 根据链接中的路由加载面包屑
      const matched = routeItemCur.matched.filter(
        item => item.meta && item.meta.title
      )

      let matchedBreadcrumb = matched.filter(
        item => item.meta && item.meta.title && item.meta.breadcrumb !== false
      )

      if(isOnlyShowCurRoute){
        matchedBreadcrumb = [routeItemCur]
      }

      const breadCrumbDataList = []
      const dynamicRouteAll = commonRoutes//dynamicRoutes.concat(commonRoutes)
      // let menuItemNew = {
      //   // id: "0",
      //   name: 'layout',
      //   meta: { title: '首页' },
      //   icon: 'el-icon-menu',
      //   path: '/'
      // }
      // breadCrumbDataList.push(menuItemNew)
      for (let i = 0; i < matchedBreadcrumb.length; i++) {
        const matchedItem = matchedBreadcrumb[i]
        // menuItemNew = {
        //   id: matchedItem.name,
        //   name: matchedItem.meta.title,
        //   title: matchedItem.meta.title,
        //   icon: matchedItem.meta.icon,
        //   url: matchedItem.path
        // }
        addParentRouteToBreadCrumbData(dynamicRouteAll,breadCrumbDataList,matchedItem,false)
        breadCrumbDataList.push(Object.assign({}, matchedItem))
      }

      thisObj.breadcrumbList = breadCrumbDataList

      const navCom = thisObj.$refs.myNavItem.$children[0] // 菜单组件
      const oldActiveIndex = navCom.activeIndex // 原来的activeIndex
      if (isSetActiveIndex) {
        if (breadCrumbDataList.length > 1) {
          // 如果默认不显示首页面包屑，则应该是>0
          const menuItemID =
            breadCrumbDataList[breadCrumbDataList.length - 1].id
          thisObj.activeIndex = menuItemID
        } else {
          thisObj.activeIndex = ''
        }
      }
      if (oldActiveIndex || oldActiveIndex == 0) {
        const oldItem = navCom.items[oldActiveIndex] // 原来选中的项
        if(oldItem){
          oldItem.$el.blur()
        }
      }
    },
    LoadBreadCrumbList(thisObj, routeItemCur, isSetActiveIndex) {
      // 根据菜单加载面包屑列表
      const menuList = this.$refs.myNavItem.menuList // myNav.data().menuList; //菜单列表
      // const routePath = routeItemCur.path
      // const routeName = routeItemCur.name
      const breadCrumbDataList = []

      GetBreadCrumbDataList(menuList, routeItemCur, breadCrumbDataList)
      thisObj.breadcrumbList = breadCrumbDataList

      const navCom = thisObj.$refs.myNavItem.$children[0] // 菜单组件
      const oldActiveIndex = navCom.activeIndex // 原来的activeIndex
      if (isSetActiveIndex) {
        // 设置导航菜单
        if (breadCrumbDataList.length > 0) {
          let menuItemLast = breadCrumbDataList[breadCrumbDataList.length - 1] // 面包屑的最后一个
          const routeNameParent = menuItemLast.meta.routeNameParent // 父路由名称
          if (
            routeNameParent !== undefined &&
            routeNameParent !== null &&
            routeNameParent !== '' &&
            breadCrumbDataList.length > this.breadCrumbRoutePComputeCount
          ) {
            // menuItemLast = breadCrumbDataList[breadCrumbDataList.length - 2]
            for (let i = 0; i < breadCrumbDataList.length; i++){
              let breadCrumbDataItem = breadCrumbDataList[i]
              if(breadCrumbDataItem.name === routeNameParent){
                menuItemLast = breadCrumbDataItem
                break
              }
            }
          }
          let menuItemLastPath = menuItemLast.path
          if (
            menuItemLastPath.lastIndexOf('/') ===
            menuItemLastPath.length - 1
          ) {
            menuItemLastPath = menuItemLastPath.substr(
              0,
              menuItemLastPath.length - 1
            )
          }
          const menuItemID = menuItemLastPath
          // console.log(thisObj.$refs.myNavItem)
          thisObj.activeIndex = menuItemID
          // const navCom = thisObj.$refs.myNavItem.$children[0] // 菜单组件
          // const oldActiveIndex = navCom.activeIndex // 原来的activeIndex
          // if (
          //   oldActiveIndex !== undefined &&
          //   oldActiveIndex !== null &&
          //   oldActiveIndex !== ''
          // ) {
          //   // console.log(this.$refs.myNavItem.$children[0].items[oldActiveIndex].onMouseEnter)
          //   // console.log(this.$refs.myNavItem.$children[0].items[oldActiveIndex].onMouseLeave)
          //   const oldItem = navCom.items[oldActiveIndex] // 原来选中的项
          //   // let oldItemParent = oldItem.$parent; //父目录
          //   // navCom.closeMenu(oldItemParent.index); //关闭目录
          //   // navCom.openMenu(oldItemParent.index); //关闭目录
          //   // console.log(oldItem)
          //   // oldItem.onMouseEnter()

          //   // console.log(oldItem.$el.blur)
          //   oldItem.$el.blur()
          //   // const oldItemTimeOut = window.setTimeout(function() {
          //   //   oldItem.onMouseLeave()
          //   //   window.clearTimeout(oldItemTimeOut)
          //   // }, 100)
          // }
          navCom.updateActiveIndex(menuItemID) // 更新激活项
          //  this.$refs.myNavItem.$children[0].handleItemClick({index:menuItemLast.path})//更新激活项
          // console.log(this.$refs.myNavItem.activeIndex)
        } 
        else {
          thisObj.activeIndex = ''
        }
        // if(thisObj.$refs.myNavItem.key){
        //   thisObj.$refs.myNavItem.key++
        // }
        // else{
        //   thisObj.$refs.myNavItem.key = 1
        // }
      }
      if (oldActiveIndex || oldActiveIndex == 0) {
        const oldItem = navCom.items[oldActiveIndex] // 原来选中的项
        if(oldItem){
          oldItem.$el.blur()
        }
      }
    }
  }
}

// 获取面包屑数据列表
function GetBreadCrumbDataList(
  menuList,
  routeCur,
  breadCrumbDataList,
  isAddHomePage,
  menuIndex
) {
  //  breadCrumbDataList = (breadCrumbDataList==undefined||breadCrumbDataList==null)? []:breadCrumbDataList;//面包屑数据数组
  if (
    menuList === undefined ||
    menuList === null ||
    menuList.length === 0 ||
    breadCrumbDataList === undefined ||
    breadCrumbDataList === null
  ) {
    return
  }
  isAddHomePage = false
  //   isAddHomePage === undefined || isAddHomePage === null ? true : isAddHomePage
  // menuIndex = menuIndex === undefined || menuIndex === null ? 0 : menuIndex

  const length = breadCrumbDataList.length // 数组长度
  let menuItemNew
  for (let i = 0; i < menuList.length; i++) {
    const menuItem = menuList[i]
    const routeCurPath = routeCur.path
    if (routeCurPath.lastIndexOf('/') === routeCurPath.length - 1) {
      routeCurPath = routeCurPath.substr(0, routeCurPath.length - 1)
    }
    if (
      (menuItem.path !== '' &&
        menuItem.path.toLowerCase() === routeCurPath.toLowerCase()) ||
      (menuItem.name !== undefined &&
        menuItem.name !== null &&
        menuItem.name === routeCur.name)
    ) {
      menuItemNew = Object.assign({}, menuItem)
      breadCrumbDataList.splice(0, 0, menuItemNew)

      // 如果当前路由存在父路由名称，则根据父路由名称获取对应的父路由
      const routeNameParent = routeCur.meta.routeNameParent // 父路由名称
      const isRootRouteWhenOnlyOneL =
        routeCur.isOnlyOneLevel === true || routeCur.meta.isOnlyOneLevel === true
      if (
        isRootRouteWhenOnlyOneL !== true &&
        routeNameParent !== undefined &&
        routeNameParent !== null &&
        routeNameParent !== ''
      ) {
        const dynamicRouteAll = dynamicRoutes//.concat(commonRoutes)
        // const routeCurParent = permissionOperate.getRouteParentByName(
        //   dynamicRoutes,
        //   routeNameParent,
        //   isRootRouteWhenOnlyOneL
        // ) // 根据父路由名称寻找父路由
        // if (routeCurParent !== undefined && routeCurParent !== null) {
        //   breadCrumbDataList.splice(0, 0, Object.assign({}, routeCurParent)) // 添加父路由到面包屑集合中
        // }
        addParentRouteToBreadCrumbData(dynamicRouteAll,breadCrumbDataList,routeCur,isRootRouteWhenOnlyOneL)
      }
      break
    }
    if (
      menuItem.children !== undefined &&
      menuItem.children !== null &&
      menuItem.children.length > 0
    ) {
      const menuIndexNew = menuIndex + 1
      GetBreadCrumbDataList(
        menuItem.children,
        routeCur,
        breadCrumbDataList,
        isAddHomePage,
        menuIndexNew
      )
      if (length !== breadCrumbDataList.length) {
        // 长度有变化，说明添加了子对象，则添加当前对象
        menuItemNew = Object.assign({}, menuItem)
        breadCrumbDataList.splice(0, 0, menuItemNew)
        break
      }
    }
  }
  if (isAddHomePage && menuIndex === 0) {
    // && breadCrumbDataList.length > 0
    menuItemNew = {
      // id: "0",
      name: 'layout',
      meta: { title: '首页' },
      icon: 'el-icon-menu',
      path: '/'
    }
    breadCrumbDataList.splice(0, 0, menuItemNew)
  }
}

//添加父路由到面包屑集合中
function addParentRouteToBreadCrumbData(dynamicRoutes,breadCrumbDataList,routeCur,isRootRouteWhenOnlyOneL){
  let routeNameParent = routeCur.meta.routeNameParent // 父路由名称
  if(routeCur.meta.routeNamePrevious){
    routeNameParent = routeCur.meta.routeNamePrevious//实际的上一页的路由名称
  }
  if (isRootRouteWhenOnlyOneL !== true && routeNameParent) {
    const routeCurParent = permissionOperate.getRouteParentByName(
      dynamicRoutes,
      routeNameParent,
      isRootRouteWhenOnlyOneL
    ) // 根据父路由名称寻找父路由
    if (routeCurParent) {
      breadCrumbDataList.splice(0, 0, Object.assign({}, routeCurParent)) // 添加父路由到面包屑集合中
      addParentRouteToBreadCrumbData(dynamicRoutes,breadCrumbDataList,routeCurParent,isRootRouteWhenOnlyOneL)
    }
  }
}
</script>
<style lang="scss" scoped>
.app-container {
  height: 100%;
}

.app-header {
  padding: 0;
}

.main-header {
  display: flex;
  align-items: center;
  padding: 0 11px;
  // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.main-container {
  overflow: auto;
  height: 0;
}
.layout-main {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100%;
}
.layout-view {
  flex-grow: 1;
  flex-shrink: 0;
  // height: 0;
  overflow-y: auto;
  padding: 10px;
}
</style>

<style>
.main-breadcrumb .el-breadcrumb__separator {
  font-weight: 400;
  color: #999999;
}

.myNavScrollbar.el-scrollbar {
  height: 100%;
}

.myNavScrollbar.el-scrollbar .el-scrollbar__wrap {
  overflow-x: hidden !important;
  max-height: 100%;
  height: 100%;
}

.myNavScrollbar.el-scrollbar .el-scrollbar__thumb {
  background-color: rgba(144, 147, 153, 0.6);
}

.myNavScrollbar.el-scrollbar .is-horizontal {
  display: none;
}

/* .el-dialog__wrapper.el-dialog-loginDialog .el-dialog__body{
  padding: 20px 5px 5px 5px;
} */

.el-dialog.el-dialog-loginDialog .el-dialog__body{
  padding: 20px 5px 5px 5px;
}
</style>
